import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from './store'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/style/index.css';
Vue.use(ElementUI);

import VueQuillEditor from 'vue-quill-editor' //富文本
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)

//import './permission' //路由权限
import { dateStr, formatDateTime } from "@/utils/im/ChatUtils.js";
Vue.prototype.formatDateTime = formatDateTime;
Vue.prototype.dateStr = dateStr;
Vue.prototype.majorIdForAll = "4db0357e4e66fbf315e0eb0a7c72f9fa";
//附件公共地址
if(window.config.VUE_IS_LOCAL) {
	Vue.prototype.baseurl = window.config.VUE_FILE_BASE_PATH;
} else {
	Vue.prototype.baseurl = window.config.VUE_FILE_OSS_PATH;
}

import * as filters from './filters' // global filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
